import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './SponsoredProducts.css';

const SponsoredProducts = () => {
  const [sponsored, setSponsored] = useState([]);
  const [authors, setAuthors] = useState({}); // cache de autores
  const [failedImages, setFailedImages] = useState(new Set()); // cache de imagens que falharam
  const scrollRef = useRef(null);
  const API = process.env.REACT_APP_API;

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      if (direction === 'left') {
        scrollRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };

  const loadSponsored = async () => {
    try {
      const res = await axios.get(`${API}/admin/sponsored-ads`);
      console.log('Sponsored ads:', res.data);
      setSponsored(res.data.filter((ad) => ad.active && ad.product));
    } catch (error) {
      console.error('Erro ao carregar anúncios patrocinados:', error);
    }
  };

  useEffect(() => {
    loadSponsored();
    // eslint-disable-next-line
  }, []);

  // Busca dados completos do autor se necessário
  useEffect(() => {
    const fetchAuthors = async () => {
      const missing = sponsored
        .map(ad => ad.product?.author)
        .filter(author => author && typeof author === 'string' && !authors[author]);
      const uniqueMissing = [...new Set(missing)];
      if (uniqueMissing.length === 0) return;
      const newAuthors = { ...authors };
      await Promise.all(
        uniqueMissing.map(async (id) => {
          try {
            const res = await axios.get(`${API}/user/${id}`);
            newAuthors[id] = res.data;
          } catch (e) {
            newAuthors[id] = { name: 'Vendedor' };
          }
        })
      );
      setAuthors(newAuthors);
    };
    if (sponsored.length) fetchAuthors();
    // eslint-disable-next-line
  }, [sponsored]);

  if (!sponsored.length) return null;

  return (
    <section className="sponsored-section">
      <div className="title-container">
      </div>
      <div className="sponsored-container">
        <button 
          className="sponsored-arrow sponsored-arrow-left" 
          onClick={() => handleScroll('left')}
          aria-label="Scroll left"
        >
          ‹
        </button>
        <div className="sponsored-scroll-row" ref={scrollRef}>
          {sponsored.sort((a, b) => (a.order || 0) - (b.order || 0)).map((ad) => {
            const author = typeof ad.product.author === 'string' ? authors[ad.product.author] : ad.product.author;
            // Construir URL completa da imagem se necessário
            const imageUrl = ad.product.images && ad.product.images.length > 0 
              ? (ad.product.images[0].startsWith('http') ? ad.product.images[0] : `${API.replace('/api', '')}${ad.product.images[0]}`)
              : null;
            
            // Verificar se o ID do produto é válido
            const productId = ad.product?._id;
            if (!productId) {
              console.warn('Produto sem ID válido:', ad.product);
              return null;
            }

            return (
              <Link
                key={ad._id}
                to={`/product/${productId}`}
                className="sponsored-card"
              >
                <div className="sponsored-card-image-container">
                  {imageUrl && !failedImages.has(imageUrl) ? (
                    <img 
                      src={imageUrl}
                      alt={ad.product.name}
                      className="sponsored-card-image"
                      onError={(e) => {
                        console.error('Erro ao carregar imagem:', imageUrl);
                        setFailedImages(prev => new Set(prev).add(imageUrl));
                      }}
                    />
                  ) : (
                    <div className="sponsored-card-image-placeholder">Sem imagem</div>
                  )}
                  <div className="sponsored-badge">Destaque</div>
                </div>
                <div className="sponsored-card-content">
                  <h3 className="sponsored-card-name" title={ad.product.name}>
                    {ad.product.name || 'Produto sem nome'}
                  </h3>
                  <p className="sponsored-card-price">
                    R$ {ad.product.price ? parseFloat(ad.product.price).toFixed(2) : '0.00'}
                  </p>
                  <p className="sponsored-card-author">
                    {author?.name || 'Vendedor'}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
        <button 
          className="sponsored-arrow sponsored-arrow-right" 
          onClick={() => handleScroll('right')}
          aria-label="Scroll right"
        >
          ›
        </button>
      </div>
    </section>
  );
}

export default SponsoredProducts;
